import { context } from "../../components/wr-context";
export var isAnalyticsEnabled = function() {
    var ref;
    return !!((ref = context.state.companySettings) === null || ref === void 0 ? void 0 : ref.canAccessAnalytics);
};
